/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de apartados.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmApartados from "../../ventas/FrmApartados.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmApartadosPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmApartados">
      <FrmApartados />
    </SizeSoftXFrmPortatil>
  );
}
